export default __webpack_public_path__ + "static/media/Flexible.7cf24ae5.jpg";